import gql from 'graphql-tag';

export default gql`
  fragment prospectCustomizeItemNumberFragment on ProspectCustomizeItemNumber {
    id
    value
    poolProspectCustomizeItemId
  }
`;
